import React from "react";

const MILESTONE_COLUMN_LABELS = [
  "7% Advance (M) (PKR)",
  "1st Milestone (M) (PKR)",
  "2nd Milestone (M) (PKR)",
  "3rd Milestone (M) (PKR)",
  "4th Milestone (M) (PKR)",
  "5th Milestone (M) (PKR)",
];

const formatAmount = (value) => {
  if (value === null || value === undefined) return "";
  const num = parseFloat(value);
  if (isNaN(num)) return "";
  if (num === 0) return "-";
  const formatted = Math.abs(num).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  });
  return num < 0 ? `(${formatted})` : formatted;
};

const MilestoneStatusSection = ({ currentData }) => {
  const rows = currentData?.milestoneStatusData || [];

  if (rows.length === 0) {
    return null;
  }

  return (
    <div className="lg:col-span-5">
      <div className="text-center mb-3">
        <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-balance">
          Milestone Status
        </h3>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className="px-4 py-3 text-left text-white bg-[#137e81] font-medium border border-[#a07f0a]">
                  Sr.#
                </th>
                <th className="px-4 py-3 text-left text-white bg-[#137e81] font-medium border border-[#a07f0a]">
                  Company Name
                </th>
                <th className="px-4 py-3 text-left text-white bg-[#137e81] font-medium border border-[#a07f0a]">
                  Type
                </th>
                {MILESTONE_COLUMN_LABELS.map((label) => (
                  <th
                    key={label}
                    className="px-4 py-3 text-right text-white bg-[#137e81] font-medium border border-[#a07f0a]"
                  >
                    {label}
                  </th>
                ))}
                <th className="px-4 py-3 text-right text-white bg-[#137e81] font-medium border border-[#a07f0a]">
                  Total Approved Grant (M) (PKR)
                </th>
              </tr>
            </thead>

            <tbody>
              {rows.map((row, index) => {
                const bg = index % 2 === 0 ? "bg-[#F6F7F9]" : "bg-white";
                return (
                  <React.Fragment key={row.grant_id}>
                    <tr className={`${bg} hover:bg-gray-100 transition-colors`}>
                      <td
                        rowSpan={3}
                        className="px-4 py-3 text-left text-gray-800 border-b font-medium align-top"
                      >
                        {index + 1}
                      </td>
                      <td
                        rowSpan={3}
                        className="px-4 py-3 text-left text-gray-800 border-b font-medium align-top"
                      >
                        {row.company_name}
                      </td>
                      <td className="px-4 py-2 text-left text-gray-600 border-b">
                        Approved grant
                      </td>
                      {row.columns.map((col, i) => (
                        <td
                          key={i}
                          className="px-4 py-2 text-right text-gray-800 border-b"
                        >
                          {formatAmount(col.approved)}

                          {row.advanceAdjustMilestone === i && (
                            <span
                              className="block text-[10px] font-semibold text-amber-700 whitespace-nowrap"
                              title="The 7% advance is adjusted against this milestone"
                            >
                              7% adj.
                            </span>
                          )}
                        </td>
                      ))}
                      <td className="px-4 py-2 text-right text-gray-800 border-b font-semibold">
                        {formatAmount(row.totalApproved)}
                      </td>
                    </tr>
                    <tr className={`${bg} hover:bg-gray-100 transition-colors`}>
                      <td className="px-4 py-2 text-left text-gray-600 border-b">
                        Actual amount released
                      </td>
                      {row.columns.map((col, i) => (
                        <td
                          key={i}
                          className="px-4 py-2 text-right text-gray-800 border-b"
                        >
                          {formatAmount(col.released)}
                        </td>
                      ))}
                      <td className="px-4 py-2 text-right text-gray-800 border-b font-semibold">
                        {formatAmount(row.totalReleased)}
                      </td>
                    </tr>
                    <tr className={`${bg} hover:bg-gray-100 transition-colors`}>
                      <td className="px-4 py-2 text-left text-gray-600 border-b">
                        Difference
                      </td>
                      {row.columns.map((col, i) => (
                        <td
                          key={i}
                          className={`px-4 py-2 text-right border-b ${
                            col.difference < 0 ? "text-red-600" : "text-gray-800"
                          }`}
                        >
                          {formatAmount(col.difference)}
                        </td>
                      ))}
                      <td
                        className={`px-4 py-2 text-right border-b font-semibold ${
                          row.totalDifference < 0 ? "text-red-600" : "text-gray-800"
                        }`}
                      >
                        {formatAmount(row.totalDifference)}
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
        {rows.some((row) => row.advanceAdjustMilestone) && (
          <p className="mt-2 text-xs text-gray-500 text-left">
            <span className="font-semibold text-amber-700">7% adj.</span> marks the
            milestone the 7% advance is adjusted against.
          </p>
        )}
      </div>
    </div>
  );
};

export default MilestoneStatusSection;
